// extracted by mini-css-extract-plugin
module.exports = {"dimm":"Dimm_dimm__2Il-N","slider":"Dimm_slider__1dHNy","inputNumber":"Dimm_inputNumber__2gssW","percent":"Dimm_percent__3FwaD","noDimm":"Dimm_noDimm__LiqZi"};